import styled from 'styled-components';

import { FlexRowCentred, devices } from '../common-styles/common-styles';

export const MonthWrapper = styled.div`
  outline: none;
`;

export const MonthContainer = styled.table`
  margin-left: 3px;
  margin-right: 3px;
  @media ${devices.tablet} {
    margin-left: 8px;
    margin-right: 8px;
  }
  background-color: white;
  outline: none;
  color: white;

  th {
    padding: 5px 8px 5px 0;
    text-align: center;
    background-color: #6c8bb9;
    height: 32px;
  }

  td {
    font-size: 14px;
    height: 23px;
    /* width: 45px; */
    min-width: 24px;
    min-height: 32px;
    @media ${devices.tablet} {
      height: 30px;
      min-width: 28px;
      min-height: 38px;
    }
    @media ${devices.desktop} {
      height: 30px;
      min-width: 32px;
      min-height: 38px;
    }
  }
`;

const AvailabilityKey = styled.div`
  min-width: 5rem;
  margin: 5px;
  padding: 7px 10px;
  color: black;
  text-align: center;
`;

export const AvailabilityKeyAvailable = styled(AvailabilityKey)`
  background: #bcfcbcff;
`;

export const AvailabilityKeyUnavailable = styled(AvailabilityKey)`
  background: #ff6666;
`;

const AvailabilityTD = styled.td`
  color: black;
  text-align: right;
  padding-right: 5px;
  @media ${devices.tablet} {
    padding-right: 10px;
  }
`;

export const AAday = styled(AvailabilityTD)`
  background: #bcfcbcff;
`;

export const ASday = styled(AvailabilityTD)`
  background: linear-gradient(140deg, #bcfcbcff 0%, #bcfcbcff 50%, #ff6666 50%);
  @media ${devices.tablet} {
    background: linear-gradient(142deg, #bcfcbcff 0%, #bcfcbcff 50%, #ff6666 50%);
  }
  @media ${devices.desktop} {
    background: linear-gradient(144deg, #bcfcbcff 0%, #bcfcbcff 50%, #ff6666 50%);
  }
`;

export const ESday = styled(AvailabilityTD)`
  background: linear-gradient(140deg, #ff6666 47%, #bcfcbcff 49%, #ff6666 50%);
  @media ${devices.tablet} {
    background: linear-gradient(142deg, #ff6666 47%, #bcfcbcff 49%, #ff6666 50%);
  }
  @media ${devices.desktop} {
    background: linear-gradient(144deg, #ff6666 47%, #bcfcbcff 49%, #ff6666 50%);
  }
`;

export const EAday = styled(AvailabilityTD)`
  background: linear-gradient(140deg, #ff6666 0%, #ff6666 50%, #bcfcbcff 50%);
  @media ${devices.tablet} {
    background: linear-gradient(142deg, #ff6666 0%, #ff6666 50%, #bcfcbcff 50%);
  }
  @media ${devices.desktop} {
    background: linear-gradient(144deg, #ff6666 0%, #ff6666 50%, #bcfcbcff 50%);
  }
`;

export const BBday = styled(AvailabilityTD)`
  background: #ff6666;
`;
export const Cday = styled(AvailabilityTD)`
  background: #b9b9b9;
`;

export const DayTitle = styled.td`
  color: black;
  background-color: #b9b9b9;
  text-align: center;
  padding: 0;
  min-width: 34px;
  min-height: 38px;
`;

export const CalendarContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: fit-content;

  /**used to scroll text*/
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  /**keep scrolling when
      *finger or cursor scrolling*/
  -webkit-overflow-scrolling: touch;
`;

export const AvailabilityKeys = styled(FlexRowCentred)`
  background: white;
  width: fit-content;
  border-radius: 3px;
  padding: 5px;
  margin-left: auto;
  margin-right: auto;
`;

// export const AvailabilityKey = styled.div`
//   display: inline-block;
//   padding: 5px 10px;
//   margin: 3px;
//   width: 95px;
//   text-align: center;

//   @include tablet {
//     margin: 10px;
//     width: 100px;
//   }
// `;

// export const AvailabilityUnavailable = styled.div`
//   display: inline-block;
//   width: 200px;
//   height: 30px;
// `;

export const CarouselItem = styled.div`
  display: flex;
  flex-direction: row;
`;

// export const UpdateButtonWrapper = styled.div`
//   width: 20rem;
//   margin: 1rem auto;
//   background: white;
//   border-radius: 3px;
// `;
